
import React from 'react';

const Loader = () => {
    return (
        <div className="flex justify-center items-center py-10">
            <div className="loader"></div>
        </div>
    );
};

export default Loader;
